import React from 'react';
import { useNavigate } from 'react-router-dom';
import s from './StartButton.module.css';
import { OptimizedMotion } from '../../../../shared/ui/optimized-motion/OptimizedMotion';

const StartButton = ({ className }: { className?: string }) => {
    const navigate = useNavigate();

    const handleRequestDemo = () => {
        navigate('/contact');
    };

    return (
        <OptimizedMotion className={s.buttonsWrapper} type="slide-left" delay={0.6}>
            <button className={`${s.button} ${className}`} onClick={handleRequestDemo}>
                Request a Demo
            </button>
        </OptimizedMotion>
    );
};

export default StartButton;
